<template>
  <div>该功能正在开发中</div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style>
</style>